import { render, staticRenderFns } from "./LeadershipHome.vue?vue&type=template&id=335ffec4&scoped=true"
import script from "./LeadershipHome.vue?vue&type=script&lang=js"
export * from "./LeadershipHome.vue?vue&type=script&lang=js"
import style0 from "./LeadershipHome.vue?vue&type=style&index=0&id=335ffec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ffec4",
  null
  
)

export default component.exports